import{formatCPFCNPJ as r}from"../../internal/SocialSecurityNumberBrazil/utils.js";const i={socialSecurityNumber:i=>r(i)};export{i as pixFormatters};
//# sourceMappingURL=utils.js.map
